var _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsLoader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.4,
    cy: 10,
    r: 1.35
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: -0.7,
    calcMode: "spline",
    dur: "0.8s",
    keySplines: ".42,0,.58,1; 0,0,.58,1",
    keyTimes: "0; 0.5; 1",
    repeatCount: "indefinite",
    type: "translate",
    values: "0 2.2 ;0 -2.2; 0 2.2"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 1.35
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: -0.55,
    calcMode: "spline",
    dur: "0.8s",
    keySplines: ".42,0,.58,1; 0,0,.58,1",
    keyTimes: "0; 0.5; 1",
    repeatCount: "indefinite",
    type: "translate",
    values: "0 2.2 ;0 -2.2; 0 2.2"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.6,
    cy: 10,
    r: 1.35
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: -0.4,
    calcMode: "spline",
    dur: "0.8s",
    keySplines: ".42,0,.58,1; 0,0,.58,1",
    keyTimes: "0; 0.5; 1",
    repeatCount: "indefinite",
    type: "translate",
    values: "0 2.2 ;0 -2.2; 0 2.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsLoader);
export default __webpack_public_path__ + "cf7bea1ef6377a18a24816f27ad95d32.svg";
export { ForwardRef as ReactComponent };